module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"weather_and_sales_comparison":"Weather and Sales Comparison","staffRankingTableTitle":"Staff Performance and Ranking","Rank":"Rank","Name":"Name","Location":"Store Name","TransactionSize":"Transaction Size","HoursWorked":"Hours Worked","SCHEDULER":"Scheduler","low":"Low","high":"High"}}')
  delete Component.options._Ctor
}
